import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getEventExposureByUserId(user_id) {
    try {
        const response = await serviceContext.get(`${ReportsURL}result/open/user/${user_id}`, null, options); //+ "results/user/open/"+ user_id, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};